import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ size = "md", inverted = false }) => {
  // Cropped logo aspect ratio ~3.85:1 (5155x1340)
  const heights = {
    sm: "h-8",
    md: "h-10 lg:h-11",
    lg: "h-12 lg:h-14",
  };
  return (
    <Link to="/" data-testid="brand-logo" className="inline-flex items-center group">
      <span className={inverted ? "inline-flex bg-white rounded-lg px-3 py-2" : "inline-flex"}>
        <img
          src="/brand/oneloan-logo-trans.png"
          alt="OneLoan.in — Loan Lena Hua Asaan"
          className={`${heights[size]} w-auto object-contain transition-transform group-hover:scale-[1.02]`}
          loading="eager"
          decoding="async"
        />
      </span>
    </Link>
  );
};
